import React from 'react';

import { Divider, Text } from '@thefarmersfront/kitchen';

import { ProductRegisterModalStockInfoDefault, ProductRegisterModalStockInfoSectionDetails } from '.';

import styles from './ProductRegisterModalStockInfoSection.module.scss';

const ProductRegisterModalStockInfoSection = () => {
  return (
    <div className={styles['product-info-section']}>
      <Text className={styles['section-title']} size="xxlarge" weight="bold">
        상품 재고 정보
      </Text>

      <ProductRegisterModalStockInfoDefault />

      <div className={styles['divider-wrapper']}>
        <Divider color="gray100" />
      </div>

      <ProductRegisterModalStockInfoSectionDetails />
    </div>
  );
};

export default ProductRegisterModalStockInfoSection;
